import React, {useState, useEffect} from 'react';
import Body from "../components/Body";
import AlbumGallerySection from "../sections/AlbumGallerySection";
import ContactSection from "../sections/ContactSection";
import FooterSection from "../sections/FooterSection";
import {route} from "ziggy-js";

const Index = (props) => {
    const [page, setPage]       = useState(null);
    const [albums, setAlbums]   = useState(null);
    const [loaded, setLoaded]   = useState(false);

    useEffect(() => {
        loadPageData();
    }, []);

    const loadPageData = () => {
        axios.get(route('api.page.get', {page: 'home'}))
            .then((response) => {
                if (!!response && !!response.data) {
                    setPage(response.data);

                    loadAlbumsData();
                } else {
                    alert('Page failed to load. Please refresh to try again.');
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const loadAlbumsData = () => {
        axios.get(route('api.album.index'))
            .then((response) => {
                if (!!response && !!response.data) {
                    setAlbums(response.data.data);
                    setLoaded(true);
                } else {
                    alert('Page failed to load. Please refresh to try again.');
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    // TODO - INCLUDE NEW LOADER
    if (!loaded) {
        return (
            <>
            </>
        );
    }

    return (
        <Body>
            <AlbumGallerySection
                page={page}
                albums={albums}
            />
            <ContactSection page={page} />
            <FooterSection  page={page}/>
        </Body>
    );
}

export default Index;
